module.exports = __webpack_public_path__ + "static/img/3.e59c630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/3.png
// module id = CYQT
// module chunks = 1